export const POST_CREATE_RESET = 'POST_CREATE_RESET'
export const POST_CREATE_SET_CREATED = 'POST_CREATE_SET_CREATED'
export const POST_CREATE_SET_ERROR = 'POST_CREATE_SET_ERROR'
export const POST_CREATE_SET_VIOLATIONS = 'POST_CREATE_SET_VIOLATIONS'
export const POST_CREATE_TOGGLE_LOADING = 'POST_CREATE_TOGGLE_LOADING'
